import { Button } from "components/Button/Button";
import { useCallback } from "react";
import strings from "utils/strings";
import { ModalPrompt } from "./ModalPrompt";

interface UnsavedChangesModalProps {
    applyAction: () => void;
    saveContent?: () => Promise<any>;
    resetForm: () => void;
    setModalVisible: (isModalVisible: boolean) => void;
    isModalVisible: boolean;
}

export const UnsavedChangesModal = ({
    applyAction,
    saveContent,
    resetForm,
    setModalVisible,
    isModalVisible,
}: UnsavedChangesModalProps) => {
    const notSaveAndNotApplyAction = useCallback(() => {
        setModalVisible(false);
    }, [setModalVisible]);

    const saveAndApplyAction = useCallback(async () => {
        if (saveContent) {
            saveContent()
                ?.then(() => applyAction())
                .finally(() => setModalVisible(false));
        }
    }, [applyAction, saveContent, setModalVisible]);

    const notSaveAndApplyAction = useCallback(async () => {
        await resetForm();
        await applyAction();
        await setModalVisible(false);
    }, [applyAction, resetForm, setModalVisible]);

    return (
        <ModalPrompt
            isOpen={isModalVisible}
            titleText={strings.applyActionUnsavedPrompt}
            confirmButtonText="Save"
            onCancel={notSaveAndNotApplyAction}
            onConfirm={saveContent ? saveAndApplyAction : undefined}
            additionalActionButton={
                notSaveAndApplyAction && (
                    <Button
                        variation="danger"
                        onClick={notSaveAndApplyAction}
                        label={"Don't save"}
                    />
                )
            }
        />
    );
};
